/* eslint-disable object-curly-newline */
import React, { useState, useEffect, useRef, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import getPaymentsList from '../../../api/graphql/queries/getPaymentsList';
import getProducts from '../../../api/graphql/queries/getProducts';
import getCouponTypes from '../../../api/graphql/queries/getCouponTypes';
import useSharedFilters from '../../../hooks/useSharedFilters';

import Filter from '../../Tabs/Filter';
import SubscriptionsTable from './SubscriptionsTable';
import Toolbar from './SubscriptionsToolbar';
// import SubscriptionsForm from './SubscriptionsForm';
import SubscriptionsFormOnlyShow from './SubscriptionsFormOnlyShow';
import Modal from '../../Modal/Modal';
import LoadIcon from '../../LoadIcon';

const SubscriptionsContainer = () => {
  const [productGroup] = useState('rdl-subscription');
  const [productList, setProductList] = useState([]);
  const [couponTypesList, setCouponTypesList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isCreateModalOn, setIsCreateModalOn] = useState(false);
  const [isDisplayModalOn, setIsDisplayModalOn] = useState(false);
  const [isModifyModalOn, setIsModifyModalOn] = useState(false);
  const [isDeleteModalOn, setIsDeleteModalOn] = useState(false);
  const [formOutput, setFormOutput] = useState({});
  const [currItemData, setCurrItemData] = useState([]);
  const [toggleDeleteInfoScreen, setToggleDeleteInfoScreen] = useState([]);
  const [total, setTotal] = useState(0);
  const [query, setQuery] = useState('');
  const [downloadingAllInProgress, setDownloadingAllInProgress] = useState(false);
  const [downloadingInProgress, setDownloadingInProgress] = useState(false);

  // Shared filters (synced with URL for persistence between Users and Subscriptions tabs)
  const {
    email, setEmail,
    name, setName,
    startDate, setStartDate,
    finishDate, setFinishDate,
  } = useSharedFilters();

  // Non-shared filtering items:
  const [active, setActive] = useState(true);
  const [payed, setPayed] = useState(false);
  const [renewSubscription, setRenewSubscription] = useState(null);
  const [couponCode, setCouponCode] = useState(null);
  const [userId, setUserId] = useState(null);
  const [country, setCountry] = useState(null);
  const [present, setPresent] = useState(null);
  const [productSlugName, setProductSlugName] = useState(null);
  const [couponTypeId, setCouponTypeId] = useState(null);
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);
  const [productType, setProductType] = useState(null);
  const [provider, setProvider] = useState(null);

  // Sorting items:
  const [sorting, setSorting] = useState(['datePayment', -1]);

  // Pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [previousPage, setPreviousPage] = useState(0);
  const [avoidEffect, setAvoidEffect] = useState(false);

  const isMounted = useRef(true);

  const columns = [
    { field: '_id', type: 'string', hide: true, isId: true, align: 'left' },
    { field: 'datePayment', headerName: 'Date subscribed', type: 'date', sortable: true, align: 'left' },
    { field: 'registrationDate', headerName: 'Date registered', type: 'date', sortable: true, align: 'left' },
    { field: 'payed', headerName: 'Payed', type: 'boolean', sortable: true, align: 'center' },
    { field: 'productSlugName', headerName: 'Product', type: 'string', sortable: true, align: 'left' },
    { field: 'amount', headerName: 'Amount', type: 'string', sortable: true, align: 'right' },
    { field: 'email', headerName: 'Email', type: 'string', sortable: true, align: 'left' },
    { field: 'emailAtProvider', headerName: 'Email alt', type: 'string', sortable: true, align: 'left', description: 'Email at Paypal or Stripe' },
    { field: 'name', headerName: 'Name', type: 'string', sortable: true, align: 'left' },
    { field: 'surname', headerName: 'Last name', type: 'string', sortable: true, align: 'left' },
    { field: 'idNumber', headerName: 'DNI', type: 'string', sortable: true, align: 'left' },
    { field: 'country', headerName: 'Country', type: 'string', sortable: true, align: 'left' },
    { field: 'couponCode', headerName: 'Coupon', type: 'string', sortable: true, align: 'left' },
    { field: 'contractType', headerName: 'Type', type: 'string', sortable: true, align: 'left' },
    { field: 'subscriptionLastDate', headerName: 'Final date', type: 'date', sortable: true, align: 'left', description: 'Date when the subscription finishes or will be renewed' },
    { field: 'renewSubscription', headerName: 'Renew', type: 'boolean', sortable: true, align: 'center' },
    { field: 'provider', headerName: 'Provider', type: 'string', sortable: true, align: 'left' },
    { field: 'transactionId', headerName: 'Trans. id', type: 'string', sortable: true, align: 'left', description: 'Transaction id at Paypal or Stripe' },
    { field: 'originPost', headerName: 'Origin post', type: 'string', sortable: true, align: 'right' },
    { field: 'subscriptionFailedRenewalCounter', headerName: 'Retries', type: 'string', sortable: true, align: 'right' },
    {
      field: 'subscriptionRenewalLastError.code',
      headerName: 'Error',
      type: 'string',
      sortable: true,
      align: 'left',
      fieldFunc: row => (
        (row.subscriptionRenewalLastError && (row.subscriptionRenewalLastError.code || row.subscriptionRenewalLastError.message))
        || (row.renewSubscription !== true && 'Renew disabled by user')
      )
    },
  ];

  const clientValuesToBackValues = {
    0: null,
    1: true,
    2: false,
  };

  const formatValue = ({ column, row, value, csv = false }) => {
    if (!value) {
      return '';
    }

    switch (column.type) {
      case 'date':
        return new Date(parseInt(value, 10)).toLocaleString().replace(',', '');
      case 'boolean':
        return '✓';
      case 'array':
        return csv ? `"${value.join()}"` : value.join();
      case 'string':
      default:
        return value;
    }
  };

  useEffect(() => () => {
    isMounted.current = false;
  }, []);

  useEffect(() => {
    if (avoidEffect) {
      console.log('Avoiding effect');
      return;
    }
    let from = page * rowsPerPage;
    let to = (page + 1) * rowsPerPage;
    if (previousPage === page) {
      setAvoidEffect(true);
      setPage(0);
      from = 0;
      to = rowsPerPage;
    } else {
      from = page * rowsPerPage;
      to = (page + 1) * rowsPerPage;
      setPreviousPage(page);
    }
    console.log('Calling getPaymentsList()');
    getPaymentsList({
      active,
      payed: clientValuesToBackValues[parseInt(payed, 10)],
      renewSubscription,
      couponCode,
      userId,
      email,
      name,
      country,
      present,
      productSlugName,
      couponTypeId,
      subscriptionStatus,
      productGroup,
      productType,
      provider,
      startDate,
      finishDate,
      from,
      to,
      sortingField: sorting[0],
      sortingType: sorting[1],
    }).then((paymentsDataObject) => {
      if (!isMounted.current) return;

      if (paymentsDataObject) {
        if (paymentsDataObject.isAuth) {
          setTotal(paymentsDataObject.total);
          setQuery(paymentsDataObject.query);
          setFilteredData(paymentsDataObject.payments);
          setIsLoading(false);
        } else {
          console.log('getPaymentsList failed!');
        }
      } else {
        console.log('paymentsData = null');
      }
      setAvoidEffect(false);
    });
  }, [
    active,
    payed,
    renewSubscription,
    couponCode,
    userId,
    email,
    name,
    country,
    present,
    productSlugName,
    couponTypeId,
    subscriptionStatus,
    productGroup,
    productType,
    provider,
    startDate,
    finishDate,
    page,
    rowsPerPage,
    sorting,
  ]);

  // Get available products
  useEffect(() => {
    getProducts(null, productGroup).then((productListReceived) => {
      if (isMounted.current) setProductList(productListReceived);
    });
    getCouponTypes().then((couponTypesReceived) => {
      if (isMounted.current) setCouponTypesList(couponTypesReceived);
    });

  }, []);

  // const updateSearch = (val) => {
  //   setFilterText(val);
  //   setFilteredData(initialItems.filter(item => item.email.toLowerCase().includes(val.toLowerCase())));
  // };

  const toggleCreateModal = () => {
    setIsCreateModalOn(!isCreateModalOn);
  };

  const toggleDisplayModal = (item) => {
    setIsDisplayModalOn(!isDisplayModalOn);
    setCurrItemData(filteredData.find(el => el._id === item));
  };

  const toggleModifyModal = (item) => {
    setIsModifyModalOn(!isModifyModalOn);
    setCurrItemData(filteredData.find(el => el._id === item));
  };

  const toggleDeleteModal = (item) => {
    setIsDeleteModalOn(!isDeleteModalOn);
    setCurrItemData(filteredData.find(el => el._id === item));
  };

  const formOutputHandler = (value) => {
    setFormOutput(value);
    // we would send this to the DB to create an entry
  };

  const handleClick = (action, item) => {
    switch (action) {
      case 'create':
        toggleCreateModal();
        break;
      case 'display':
        toggleDisplayModal(item);
        break;
      case 'modify':
        toggleModifyModal(item);
        break;
      case 'delete':
        toggleDeleteModal(item);
        break;
      case 'closeDeleteItem':
        setToggleDeleteInfoScreen(!toggleDeleteInfoScreen);
        break;
      default:
        console.log('wrong action!');
        break;
    }
  };

  // Fastest algorythm to create CSV
  // Warning: if the data has commas or newlines this will not be a valid CSV
  const makeCsv = (rawData) => {
    const csvArr = new Array(rawData.length + 1);
    const visibleColumns = columns.filter(column => !column.hide);
    const numColumns = visibleColumns.length;
    const row = new Array(numColumns);

    // Set csv column titles
    csvArr[0] = visibleColumns.map(column => column.headerName).join(',');

    // Set data
    for (let rowNum = 0; rowNum < rawData.length; rowNum++) {
      for (let colNum = 0; colNum < numColumns; colNum++) {
        row[colNum] = formatValue({ column: visibleColumns[colNum], value: rawData[rowNum][visibleColumns[colNum].field], csv: true });
      }
      csvArr[rowNum + 1] = row.join(',');
    }
    return csvArr.join('\n');
  };

  // Fetch every matching payment in chunks and save them as a CSV.
  // `to` is an absolute row index on the backend (limit = to - from), like the paged table uses it.
  const downloadCsv = async (filters) => {
    const chunkSize = 5000;

    const totalResult = await getPaymentsList({ ...filters, from: 0, to: 0 });
    if (!totalResult || !totalResult.isAuth || totalResult.error) {
      throw new Error((totalResult && totalResult.error) || 'could not count payments');
    }

    const promises = [];
    for (let chunk = 0; chunk < Math.ceil(totalResult.total / chunkSize); chunk++) {
      promises.push(getPaymentsList({
        ...filters,
        from: chunk * chunkSize,
        to: (chunk + 1) * chunkSize,
        getTotal: false,
      }));
    }

    const rawDataChunks = await Promise.all(promises);
    const rawData = [];
    rawDataChunks.forEach((chunk, index) => {
      if (!chunk || !chunk.payments || chunk.error) {
        throw new Error(`chunk ${index + 1} of ${rawDataChunks.length} failed${chunk && chunk.error ? `: ${chunk.error}` : ''}`);
      }
      rawData.push(...chunk.payments);
    });

    const data = makeCsv(rawData);
    const element = document.createElement('a');
    const file = new Blob([data], { type: 'text/csv;charset=utf-8;' });
    element.href = URL.createObjectURL(file);
    element.download = 'subscriptions.csv';
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  };

  const handleDownload = async () => {
    setDownloadingInProgress(true);
    try {
      await downloadCsv({
        active,
        payed: clientValuesToBackValues[parseInt(payed, 10)],
        renewSubscription,
        couponCode,
        userId,
        email,
        name,
        country,
        present,
        productSlugName,
        couponTypeId,
        subscriptionStatus,
        productGroup,
        productType,
        provider,
        startDate,
        finishDate,
      });
    } catch (error) {
      // eslint-disable-next-line no-alert
      alert(`Download failed: ${error.message}`);
    }
    setDownloadingInProgress(false);
  };

  const handleDownloadAll = async () => {
    setDownloadingAllInProgress(true);
    try {
      await downloadCsv({});
    } catch (error) {
      // eslint-disable-next-line no-alert
      alert(`Download failed: ${error.message}`);
    }
    setDownloadingAllInProgress(false);
  };

  return (
    <Fragment>
      <div className="w-full bg-white">
        <div className="flex justify-between mb-4">
          <span className="font-americaMonoBold text-14 uppercase">
            Total:
            {total}
          </span>
          {/* <button
            type="button"
            className="font-americaMonoBold text-xs px-6 rounded-full bg-black text-white uppercase"
            onClick={() => {
              handleClick('create');
            }}
          >
            Create User
          </button> */}
        </div>
        {isDisplayModalOn && (
          <Modal title="Display Subscription" handleClick={handleClick} type="display">
            <SubscriptionsFormOnlyShow handleClick={handleClick} formInput={currItemData} action="display" />
          </Modal>
        )}
        {/* {isDisplayModalOn && (
          <Modal title="Display Subscription" handleClick={handleClick} type="display">
            <SubscriptionsForm handleClick={handleClick} formInput={currItemData[0]} action="display" />
          </Modal>
        )} */}
        {/* {isModifyModalOn && (
          <Modal title="Modify Subscription" handleClick={handleClick} type="modify">
            <SubscriptionsForm handleClick={handleClick} retrieveOutput={formOutputHandler} formInput={currItemData[0]} action="modify" />
          </Modal>
        )} */}
        <div className="mt-4">
          {!isLoading ? (
            <>
              <Toolbar
                active={active}
                setActive={setActive}
                payed={payed}
                setPayed={setPayed}
                renewSubscription={renewSubscription}
                setRenewSubscription={setRenewSubscription}
                couponCode={couponCode}
                setCouponCode={setCouponCode}
                userId={userId}
                setUserId={setUserId}
                email={email}
                setEmail={setEmail}
                name={name}
                setName={setName}
                present={present}
                setPresent={setPresent}
                productSlugName={productSlugName}
                setProductSlugName={setProductSlugName}
                setCouponTypeId={setCouponTypeId}
                subscriptionStatus={subscriptionStatus}
                setSubscriptionStatus={setSubscriptionStatus}
                productList={productList}
                couponTypesList={couponTypesList}
                productType={productType}
                setProductType={setProductType}
                provider={provider}
                setProvider={setProvider}
                startDate={startDate}
                setStartDate={setStartDate}
                finishDate={finishDate}
                setFinishDate={setFinishDate}
                country={country}
                setCountry={setCountry}
                handleDownload={handleDownload}
                handleDownloadAll={handleDownloadAll}
                downloadingInProgress={downloadingInProgress}
                downloadingAllInProgress={downloadingAllInProgress}
              />
              <SubscriptionsTable
                tableData={filteredData}
                columns={columns}
                onRowClick={id => handleClick('display', id)}
                stickyHeader
                total={total}
                page={page}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                sorting={sorting}
                setSorting={setSorting}
                formatValue={formatValue}
              />
              <div style={{ color: '#fff' }}>
                {query}
              </div>
            </>
          ) : <LoadIcon />}
        </div>
      </div>
    </Fragment>
  );
};

SubscriptionsContainer.propTypes = {
};

export default withRouter(SubscriptionsContainer);
